import React from 'react';
import { Card, Link, PillButton, Row, Text } from 'library/ui';
import { useModalsContext } from 'ModalsContext';
import type { IProviderSearch } from '../ProvidersSearchAndFilter/models';

export default function StaffSendJob({
    selectedProviders,
    resetSelectedProviders,
}: {
    selectedProviders: IProviderSearch[];
    resetSelectedProviders: () => void;
}) {
    const { openJobForm } = useModalsContext();

    if (selectedProviders.length === 0) return null;

    return (
        <Card tone="muted" padding="sm">
            <Row gap="md" align="center">
                <Text weight="semibold">{selectedProviders.length} selected</Text>
                <PillButton
                    onClick={() =>
                        openJobForm(
                            'Staff List',
                            {
                                pastProviders: selectedProviders.map((p) => {
                                    return {
                                        name: p.user.first_name,
                                        firstName: p.user.first_name,
                                        id: p.user.id,
                                        providerId: p.id,
                                    };
                                }),
                                pageNumber: 0,
                                frequency: 'onetime',
                            },
                            resetSelectedProviders,
                        )
                    }
                >
                    Post Job
                </PillButton>
                <Link onClick={resetSelectedProviders} underline={false}>
                    Clear
                </Link>
            </Row>
        </Card>
    );
}
